import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,  
  selector: 'app-forbidden',
  imports: [RouterModule],
  templateUrl: './forbidden.component.html',
  styleUrl: './forbidden.component.css',
})
export class ForbiddenComponent {}
